import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpEventType,
  HttpResponse,
} from "@angular/common/http";
import { RequestOptions } from "@angular/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class AdvtService {
  public progress: number;

  constructor(private http: HttpClient) { }

  getAllCategories() {
    return this.http
      .get<any>(environment.apiUrl + "seller/listcategories")
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getAllSubCategories(categoryId) {
    return this.http
      .get<any>(environment.apiUrl + "seller/listsubcategories/" + categoryId)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  // getAll(params) {
  //   return this.http.get<any>( environment.apiUrl + 'searchitems' , params).map(data => {
  //     if (data) {
  //       return data;
  //     } else {
  //       return [];
  //     }
  //   });
  // }

  getBidTypes() {
    return this.http.get<any>(environment.apiUrl + "bid/types").map((data) => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }

  getSellerRating(seller_id) {
    return this.http
      .get<any>(environment.apiUrl + `sellerratings/${seller_id}`)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  getListSubCategories(id) {
    return this.http
      .get<any>(environment.apiUrl + `seller/listsubcategories/${id}`)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getCompairRates(category, keyword, limit, offset) {
    return this.http
      .get<any>(
        environment.apiUrl +
        `seller/getCompairRatesWeb/${category}/${keyword}/${limit}/${offset}`
      )
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  // createNewItem(adData) {
  //   // Seller Detail
  //   var userInfo = JSON.parse(localStorage.getItem("currentUser"));
  //   adData.seller_id = userInfo.result.id;
  //   adData.videos ? adData.videos : null;
  //   adData.images ? adData.images : null;
  //   adData.music ? adData.music : null;
  //   return this.http
  //     .post<any>(environment.apiUrl + "seller/newitem", adData)
  //     .map((data) => {
  //         return data;
  //     });
  // }

  createNewItem(adData) {
    // Seller Detail
    var userInfo = JSON.parse(localStorage.getItem("currentUser"));
    adData.seller_id = userInfo.result.id;
    adData.videos ? adData.videos : null;
    adData.images ? adData.images : null;
    adData.music ? adData.music : null;
    return this.http
      .post<any>(environment.apiUrl + "seller/newitem", adData)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else if (data.status === 409) {
          return data;
        }
      });
  }

  addNewTrade(adData) {
    // Seller Detail
    var userInfo = JSON.parse(localStorage.getItem("currentUser"));
    adData.seller_id = userInfo.result.id;
    adData.videos ? adData.videos : null;
    adData.images ? adData.images : null;
    adData.music ? adData.music : null;
    return this.http
      .post<any>(environment.apiUrl + "trade/newitem", adData)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  makeSellerPayment(paymentData) {
    // Seller Detail
    return this.http
      .post<any>(environment.apiUrl + "seller/makePayment", paymentData)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  askhelp(Data) {
    return this.http
      .post<any>(environment.apiUrl + "user/help", Data)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  updateItem(adData) {
    return this.http
      .post<any>(environment.apiUrl + "seller/updateitem", adData)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }
  updateTrade(adData) {
    return this.http
      .post<any>(environment.apiUrl + "trade/updateitem", adData)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }

  // Get User Followers/Following
  getFollowerFollowing(params) {
    return this.http
      .post<any>(environment.apiUrl + "followerList", params)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  // Get Music Listing
  getListItems(seller_id, category_id, limit, offset) {
    return this.http
      .post<any>(environment.apiUrl + "seller/listitems", {
        seller_id,
        category_id,
        limit,
        offset,
      })
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  tradeHistory(data) {
    return this.http
      .post<any>(environment.apiUrl + "trade/tradelisting", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }

  myTradeItem(data) {
    return this.http
      .post<any>(environment.apiUrl + "trade/mytradeitems", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }

  searchTrade(data) {
    return this.http
      .post<any>(environment.apiUrl + "trade/searchitems", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }
  testingcdasf(images: any[], bearerToken: string) {
    const payload = { images: images };

    const headers = {
      Authorization: `Bearer ${bearerToken}`
    };

    return this.http.post<any>(
      // "https://bidjones.com/api/",
      // "https://bidjones.com/bidjones/api/v1/aitesting",
      "https://bidjones.com/bidjones/api/v1/aitesting1",
      payload,
      { headers: headers }
    );
  }

  AIimageScan(imageFile: File) {
    let headers = new HttpHeaders();
    headers.set("Accept", "application/json");

    const formData: FormData = new FormData();
    formData.append("images", imageFile);

    // POST
    return this.http
      .post<any>(
        // 'https://bidjones.com/api/',
        "https://bidjones.com/bidjones/api/v1/aitesting1",
        // "https://stgps.appsndevs.com/bidjones/api/v1/aitesting1",
        formData,
        { headers }
      );
  }

  onImageFileUpload(seller_id, media_type, imageFile: File) {
    let headers = new HttpHeaders();
    headers.set("Accept", "application/json");

    const formData: FormData = new FormData();
    formData.append("media[]", imageFile);

    // POST
    return this.http
      .post<any>(
        `${environment.apiUrl}seller/uploadmedia/${seller_id}/${media_type}`,
        formData,
        { headers }
      );
  }

  onFileUpload(seller_id, media_type, event: EventTarget) {
    let headers = new HttpHeaders();
    headers.set("Accept", "application/json");
    headers.append("Content-Type", "multipart/form-data");

    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const files: FileList = target.files;
    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("media[]", files[i]);
    }

    // POST
    return this.http
      .post<any>(
        `${environment.apiUrl}seller/uploadmedia/${seller_id}/${media_type}`,
        formData,
        { headers }
      )
      .map((res: Response) => {
        return res;
      });
  }

  deleteFile(params) {
    // const formData: FormData = new FormData();
    //   formData.append('filename', filename);
    return this.http
      .post<any>(environment.apiUrl + "seller/deletemedia", params)
      .map((res: Response) => {
        return res;
      });
  }

  searchData(params) {
    return this.http
      .post<any>(environment.apiUrl + "searchitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }
  addRadio(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/addradio", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  saveData(params) {
    return this.http
      .post<any>(environment.apiUrl + "buyer/savesearchpreference", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  searchpreferenceitems(params) {
    return this.http
      .post<any>(environment.apiUrl + "searchpreferenceitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  pendingPurchase(params) {
    return this.http
      .post<any>(environment.apiUrl + "buyer/PendingPurchases", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  itemHistory(params) {
    return this.http
      .post<any>(environment.apiUrl + "itemHistory", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  sendBit(itemId: string, bidId: string, action: string, payload: any) {
    const url = `${environment.apiUrl}seller/actionOnBid/${itemId}/${bidId}/${action}`;

    return this.http.post<any>(url, payload)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }


  postBid(amount, buyer_id, item_id) {
    const formData: FormData = new FormData();
    formData.append("amount", amount);
    formData.append("buyer_id", buyer_id);
    formData.append("item_id", item_id);
    return this.http
      .post<any>(environment.apiUrl + "seller/postBid", formData)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getSingleItem(seller_id, item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}seller/item/${seller_id}/${item_id}`)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getItemDetail(item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}itemdetail/${item_id}`)
      .map((data) => {
        if (data.status === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  // BitAcceptBuyResponse(userid){
  //   return this.http
  //   .get<any>(`${environment.apiUrl}seller/bidRecords/${userid}/10/0/sent/0`)
  //   .map((data)=>{
  //     if (data.status === 200) {
  //       return data.result;
  //     } else {
  //       return [];
  //     }
  //   })
  // }

  BitAcceptBuyResponse(userId: string, token: string) {
    const url = `${environment.apiUrl}seller/bidRecords/${userId}/10/0/sent/0`;

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    return this.http.get<any>(url, { headers })
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getSellerIdMerchantIdDetail(seller_id) {
    return this.http
      .get<any>(`${environment.apiUrl}get-mechant-id-by-seller-id/${seller_id}`)
      .map((data) => {
        if (data.status == 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getTradeItemDetail(item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}trade/tradedetail/${item_id}`)
      .map((data) => {
        if (data.status === 200) {
          return data.result[0];
        } else {
          return [];
        }
      });
  }

  getBid(user_id, limit, offset, bid_type, category_id = 0) {
    return this.http
      .get<any>(
        `${environment.apiUrl}seller/bidRecords/${user_id}/${limit}/${offset}/${bid_type}/${category_id}`
      )
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  getBidSend(user_id, limit, offset, bid_type, category_id = 0) {
    return this.http
      .get<any>(
        `${environment.apiUrl}seller/bidRecords1/${user_id}/${limit}/${offset}/${bid_type}/${category_id}`
      )
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }
 

  recievedTrade(data) {
    return this.http
      .post<any>(environment.apiUrl + "trade/receivedrequests", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  sentTrade(data) {
    return this.http
      .post<any>(environment.apiUrl + "trade/sendrequests", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  getSearchAlerts(user_id, limit, offset, lat, lng, categoryID = 0) {
    const params = {
      category_id: categoryID,
      limit: limit,
      offset: offset,
      current_lat: lat,
      current_lng: lng,
      category_type: "buyer",
    };
    return this.http
      .post<any>(environment.apiUrl + "listsearchpreferenceitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  getTradeAlerts(user_id, limit, offset, lat, lng, categoryID = 0) {
    const params = {
      category_id: categoryID,
      limit: limit,
      offset: offset,
      current_lat: lat,
      current_lng: lng,
      category_type: "trade",
    };
    return this.http
      .post<any>(environment.apiUrl + "listsearchpreferenceitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  BidRemove(id) {
    const formData: FormData = new FormData();
    formData.append("id", id);
    return this.http
      .put<any>(environment.apiUrl + "seller/deleteBid", formData)
      .map((res: Response) => {
        return res;
      });
  }

  getPaymentToken(token, params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/makePayment", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  makePartPayment(token, params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/makePartPayment", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  updateBid(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/updateBid", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  mergePickupList(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/MergePickup", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  serviceRequestList(params) {
    return this.http
      .post<any>(environment.apiUrl + "servicesRequestReceived", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  PaymentRequest(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/payForService", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getSellerInfo(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/info", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  follow_seller(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/followMe", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  item_available(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/allitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  CheckPaymentRequest(params) {
    return this.http
      .post<any>(environment.apiUrl + "seller/paymentRequest", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  getPaymentRequest(item_id: string, seller_id: string, userAccessToken: string): Observable<any> {
    const input = {
      item_id: item_id,
      seller_id: seller_id,
    };

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${userAccessToken}`,
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(`${environment.apiUrl}seller/paymentRequest`, input, { headers: headers });
  }

  rateSeller(params) {
    return this.http
      .post<any>(environment.apiUrl + "rateSeller", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getRadios(params) {
    return this.http
      .post<any>(environment.apiUrl + "buyer/listradioFiles", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  makeSeller(user_id) {
    return this.http
      .get<any>(`${environment.apiUrl}makeMeSeller/${user_id}`)
      .map((res: Response) => {
        return res;
      });
  }

  deleteItem(seller_id, item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}seller/trashitem/${seller_id}/${item_id}`)
      .map((res: Response) => {
        return res;
      });
  }

  deleteTradeItem(seller_id, item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}trade/trashitem/${seller_id}/${item_id}`)
      .map((res: Response) => {
        return res;
      });
  }

  getUserInfoId(seller_id) {
    return this.http
      .get<any>(`${environment.apiUrl}user/detail/${seller_id}`)
      .map((res: Response) => {
        return res;
      });
  }

  getUserInfo() {
    return this.http
      .get<any>(environment.apiUrl + "user/detail")
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  acceptpay(params) {
    return this.http
      .post<any>(environment.apiUrl + "buyer/approveReject", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  acceptRejectTrade(params) {
    return this.http
      .post<any>(environment.apiUrl + "trade/acceptrejectrequest", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  updatePayment(params) {
    return this.http
      .post<any>(environment.apiUrl + "trade/updatepayment", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  sendchatmessage(params) {
    // console.log(
    //   "URL called for sending chat message..",
    //   environment.apiUrl + "notifyNewChat"
    // );
    return this.http
      .post<any>(environment.apiUrl + "notifyNewChat", params)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  getDashboardCount() {
    return this.http
      .get<any>(environment.apiUrl + "getItemsCount")
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  // Get all rating
  getRatingList(params) {
    return this.http
      .post<any>(environment.apiUrl + "sellerratings", params)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  recievedFreeProduct(data) {
    return this.http
      .post<any>(environment.apiUrl + "free/receivedrequests", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return [];
        }
      });
  }

  getFreeAlerts(user_id, limit, offset, lat, lng, categoryID = 0) {
    const params = {
      category_id: categoryID,
      limit: limit,
      offset: offset,
      current_lat: lat,
      current_lng: lng,
      category_type: "free",
    };
    return this.http
      .post<any>(environment.apiUrl + "listsearchpreferenceitems", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  freeHistory(data) {
    return this.http
      .post<any>(environment.apiUrl + "free/itemlisting", data)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }

  acceptRejectRequest(params) {
    return this.http
      .post<any>(environment.apiUrl + "free/acceptrejectrequest", params)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getFreeItemDetail(item_id) {
    return this.http
      .get<any>(`${environment.apiUrl}free/item/freedetail/${item_id}`)
      .map((data) => {
        if (data.status === 200) {
          return data.result[0];
        } else {
          return [];
        }
      });
  }

  /* getimageurl(imageurl) {
     let headers = new HttpHeaders();
    headers.set('Access-Control-Allow-Methods', 'HEAD, GET, PUT, POST, DELETE');
    headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get<any>(imageurl+'?abcd',{ headers:headers ,responseType: 'blob'}).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  } */
}



// WEBPACK FOOTER //
// ./src/app/_services/advt.service.ts